




import { Component, Prop, Vue } from "vue-property-decorator";

import { RouteName } from "@/consts/route";

@Component({})
export default class RedirectPage extends Vue {
  @Prop({ default: RouteName.Home }) name!: string;

  mounted(): void {
    this.$router.replace({ name: this.$props.name });
  }
}
